import { Component, OnInit, ViewChild } from "@angular/core";
import { ProveedoresService } from "./proveedores.service";
import { ListColumn } from "src/app/models/list-columns.model";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ProveedorForm } from "./form/form.component";
import Swal from "sweetalert2";
import { LayoutsService } from "src/app/services/layouts.service";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { ProveedorDTO } from "src/app/models/dto/proveedor.dto";
import { Filter } from "src/app/shared/classes/filter";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { ProveedorDrawerForm } from "./drawer-form/drawer-form.component";
import { DrawerService } from "src/app/services/drawer.service";

@Component({
  selector: "app-proveedores",
  templateUrl: "./proveedores.component.html",
  styles: [],
})
export class ProveedoresComponent extends CrudComponent<ProveedorDTO> {
  columnId: string = "IdProveedor";
  public columns: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Direccion",
      property: "Direccion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  realdata: ProveedorDTO[];

  constructor(
    public service: ProveedoresService,
    private layoutService: LayoutsService,
    public alerts: AlertasSwalService,
    public drawer: DrawerService,
  ) {
    super(service, alerts);
    this.filter = new Filter<ProveedorDTO>(this.conditions, this.columns, true);
    this.filter.setColumnActive(this.columnActive);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.layoutService.changeHeader("Proveedores");
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<ProveedorDTO>;
  public conditions: Condition<ProveedorDTO> = {
    Nombre: (o, f) => (o.Nombre ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Direccion: (o, f) =>
      (o.Direccion ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter


    openUser() {
      const drawerRef = this.drawer.open({
        component: ProveedorDrawerForm,
        data: { mode: "create", value: {} },
        width: "500px",
        title: "Proveedores",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Guardar",
            action: (component: ProveedorDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }

    override openEdit(value: any) {
      const drawerRef = this.drawer.open({
        component: ProveedorDrawerForm,
        data: { mode: "update", value: value },
        width: "500px",
        title: "Proveedores",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Actualizar",
            action: (component: ProveedorDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }
    public tableActionsCC = [
      {
        label: "Nuevo",
        icon: "plus",
        className:
          "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
        action: () => this.openUser(),
      },
    ];
}
